import { redirect } from 'react-router-dom';
import logoutRequest from '@justpark/api/src/requests/logout';
import { clearAuth } from '../stores/auth';

const logoutLoader = async ({ dispatch, authPromise, jpApiClient }) =>
  authPromise
    .then(() => {
      const request = logoutRequest();

      return jpApiClient(request);
    })
    .then(() => dispatch(clearAuth()))
    .then(() => redirect('/'));

export default logoutLoader;
